<template>
  <div v-if="can('add-user')">
    <h2>Add Staff</h2>
    <div class="custom-form">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <ValidationProvider name="title" rules="required" v-slot="{ errors }">
            <div class="form-group my-4">
              <label for="name">Name<Astrik /></label>
              <input
                type="text"
                v-model="name"
                class="form-control"
                id="title"
              />
              <span>{{ errors[0] }}</span>
            </div>
          </ValidationProvider>

          <ValidationProvider
            name="email"
            rules="required|email"
            v-slot="{ errors }"
          >
            <div class="form-group my-4">
              <label for="email">Email<Astrik /></label>
              <input
                type="text"
                v-model="email"
                class="form-control"
                id="email"
              />
              <span>{{ errors[0] }}</span>
            </div>
          </ValidationProvider>

          <ValidationProvider
            name="password"
            rules="required"
            v-slot="{ errors }"
          >
            <div class="form-group my-4">
              <label for="password">Password<Astrik /></label>
              <input
                type="password"
                v-model="password"
                class="form-control"
                id="password"
              />
              <span>{{ errors[0] }}</span>
            </div>
          </ValidationProvider>

          <ValidationProvider
            name="password_confirmation"
            rules="required"
            v-slot="{ errors }"
          >
            <div class="form-group my-4">
              <label for="password_confirmation"
                >Confirm Password<Astrik
              /></label>
              <input
                type="password"
                v-model="password_confirmation"
                class="form-control"
                id="password_confirmation"
              />
              <span>{{ errors[0] }}</span>
            </div>
          </ValidationProvider>

          <ValidationProvider name="sort" rules="required" v-slot="{ errors }">
            <div class="form-group my-4">
              <label for="title">Sort<Astrik /></label>
              <input
                type="text"
                v-model="sort"
                class="form-control"
                id="title"
              />
              <span>{{ errors[0] }}</span>
            </div>
          </ValidationProvider>

          <ValidationProvider
            name="status"
            rules="required"
            v-slot="{ errors }"
          >
            <div class="form-group my-4">
              <label for="title">Status<Astrik /></label>
              <select class="form-select" v-model="status">
                <option
                  :value="status.value"
                  v-for="(status, index) in $store.state.status"
                  :key="index"
                >
                  {{ status.label }}
                </option>
              </select>
              <span>{{ errors[0] }}</span>
            </div>
          </ValidationProvider>

          <div class="button-form-group">
            <button type="submit" class="btn btn-success">Submit</button>
            <router-link
              class="text-decoration-none btn btn-danger pull-right"
              :to="{
                name: 'UserList',
              }"
            >
              Cancel
            </router-link>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddUser",
  data() {
    return {
      users: [],
      loading: false,
      submitting: false,
      name: "",
      email: "",
      password: "",
      password_confirmation: "",
      sort: 1,
      status: 1,
    };
  },

  methods: {
    onSubmit() {
      this.submitting = true;
      const formData = new FormData();
      formData.append("name", this.name);
      formData.append("email", this.email);
      formData.append("password", this.password);
      formData.append("password_confirmation", this.password_confirmation);
      formData.append("status", this.status);
      formData.append("sort", this.sort);

      this.$http
        .post("user", formData)
        .then((res) => {
          if (res.data.status == 1) {
            this.$notify({
              group: "notifications",
              title: "User",
              type: "success",
              text: res.data.message,
            });
            this.$router.push({
              name: "UserList",
            });
          } else {
            this.$notify({
              group: "notifications",
              title: res.data.message,
              type: "error",
              text: res.data.errors[0],
            });
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  },
};
</script>
